import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ACCESSTOKEN_LAZADA, settings } from "../../utils/config";

const initialState = {
  token: null,
  isLoading: false,
};

export const conect = createAsyncThunk(
  "connectLazada/conect",
  async (dataInput) => {
    try {
      // TODO: Replace with real Lazada OAuth API call
      const data = {
        status: 200,
        message: "Kết nối thành công",
        data: {
          access_token: dataInput.access_token,
          idw: dataInput.idw,
        },
      };
      return data;
    } catch (error) {
      throw new Error("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

const connectLazada = createSlice({
  name: "connectLazada",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(conect.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(conect.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload;
        settings.setCookie(
          ACCESSTOKEN_LAZADA,
          action.payload.data.access_token,
          1 / 4
        );
        settings.setCookie("idw_lazada", action.payload.data.idw, 1 / 4);
      })
      .addCase(conect.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default connectLazada.reducer;
